import { heroStats } from '@/mocks/home';

export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[620px] md:min-h-[680px] flex items-center pt-16 overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-40 -right-40 w-[600px] h-[600px] rounded-full bg-primary-100/40 blur-3xl"></div>
        <div className="absolute -bottom-32 -left-32 w-[500px] h-[500px] rounded-full bg-accent-100/30 blur-3xl"></div>
      </div>

      <div className="relative w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-center gap-8 md:gap-12 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-accent-100/70 text-accent-700 text-xs font-medium mb-5">
              <i className="ri-fire-line text-sm"></i>
              <span>每日更新 · 即点即看 · 全程免费</span>
            </div>

            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl text-foreground-950 leading-tight mb-4">
              七七影院
              <span className="block text-2xl md:text-3xl lg:text-4xl text-foreground-700 mt-1">
                高清免费电影电视剧在线观看平台
              </span>
            </h1>

            <p className="text-base md:text-lg text-foreground-600 mb-4 font-heading font-light">
              海量高清资源 · 不缓冲不付费 · 打开即看
            </p>

            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-6 max-w-xl mx-auto lg:mx-0">
              七七影院汇聚超过<strong className="text-primary-500 font-semibold">10万部</strong>高清电影与电视剧资源，涵盖动作、喜剧、科幻、悬疑、爱情、动漫等全品类内容。采用先进的<strong className="text-primary-500 font-semibold">CDN加速与自适应码率技术</strong>，确保您在任何网络环境下都能获得流畅不缓冲的观影体验。每日由专业编辑团队精选更新，热门剧集同步上线，无需注册、无需付费、无需等待——<strong className="text-primary-500 font-semibold">打开网页，即刻享受影院级视听盛宴</strong>。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4 md:gap-6 mb-7">
              {heroStats.map((stat) => (
                <div key={stat.label} className="flex items-center gap-2">
                  <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100/70 text-primary-500">
                    <i className={`${stat.icon} text-lg`}></i>
                  </div>
                  <div className="text-left">
                    <div className="text-lg md:text-xl font-bold text-foreground-950 font-heading">{stat.value}</div>
                    <div className="text-xs text-foreground-600">{stat.label}</div>
                  </div>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#app"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 bg-primary-500 text-background-50 font-semibold rounded-lg hover:bg-primary-600 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm no-underline"
              >
                <i className="ri-play-circle-line text-lg"></i>
                立即观影
              </a>
              <a
                href="#features"
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-3 border border-secondary-300 text-foreground-700 font-medium rounded-lg hover:bg-secondary-50 transition-colors duration-200 whitespace-nowrap cursor-pointer text-sm no-underline"
              >
                <i className="ri-information-line text-lg"></i>
                了解更多
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-lg lg:max-w-none">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-br from-primary-200/30 via-accent-100/20 to-secondary-100/30 rounded-2xl blur-xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=Warm%20cinema%20theater%20interior%20with%20red%20velvet%20curtains%20and%20golden%20spotlight%2C%20empty%20stage%20with%20soft%20dramatic%20lighting%2C%20elegant%20atmosphere%2C%20warm%20amber%20and%20coral%20tones%2C%20cinematic%20composition%2C%20no%20people%2C%20artistic%20photography%2C%20film%20projector%20beam%20effect&width=1400&height=900&seq=hero-visual&orientation=landscape"
                alt="七七影院 - 高清免费电影在线观看平台"
                title="七七影院 - 高清免费电影在线看"
                className="relative w-full h-auto rounded-2xl object-cover shadow-lg"
                style={{ aspectRatio: '14/9' }}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}